/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFolderCancel = createReactComponent("folder-cancel", "IconFolderCancel", [
  [
    "path",
    {
      d: "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3",
      key: "svg-0"
    }
  ],
  ["path", { d: "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M17 21l4 -4", key: "svg-2" }]
]);

export { IconFolderCancel as default };
//# sourceMappingURL=IconFolderCancel.js.map
